<template>
  <div>
    <v-dialog
      v-model="show"
      content-class="crud-dialog"
      persistent
      max-width="560px"
    >
      <v-card class="crud-card">
        <v-card-title class="crud-card-title">
          <v-row no-gutters>
            <v-col cols="11" class="text-left">
              <h2 class="text-h5">Terms and Conditions</h2>
            </v-col>
          </v-row>
        </v-card-title>
        <v-divider />
        <v-card-text class="crud-card-text">
          <div class="body-text">
            Before proceeding, you need to accept the terms and conditions.
          </div>

          <div class="terms-and-conditions-container">
            <Checkbox
              v-model="acceptedTerms"
              :label="`I accept the`"
              :checkboxLink="`pdfs/Terms-and-Conditions-Competition-VC.pdf`"
              :checkboxLinkText="`terms & conditions`"
              color="primary"
            />
          </div>

          <div class="button-container">
            <GradientButton
              :title="'Continue'"
              :small="false"
              :disabled="!acceptedTerms"
              @gradientButtonClicked="acceptedCompetitionTerms"
            />
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    name: 'VodacomCompetitionPopup',
    props: {
      value: { type: Boolean },
    },
    data() {
      return {
        acceptedTerms: false,
      };
    },
    computed: {
      show: {
        get() {
          return this.value;
        },
        set(value) {
          this.$emit('input', value);
        },
      },
    },
    methods: {
      acceptedCompetitionTerms() {
        if (!this.acceptedTerms) return;
        localStorage.setItem('acceptedCompetitionTermsFromVodacom', 'true');
        this.show = false;
      },
    },
  };
</script>

<style scoped lang="scss">
  .crud-dialog {
    .crud-card {
      .crud-card-title {
        padding: 24px 24px 0 24px;

        .close {
          cursor: pointer;
          font-size: 24px;
        }

        h2 {
          font-size: 20px;
          font-weight: 600;
          line-height: 24px;
          color: #333;
          margin: 0;
        }
      }

      .crud-card-text {
        padding: 24px;

        .main-heading {
          font-size: 24px;
          font-weight: 700;
          line-height: 31.2px;
          margin-bottom: 24px;
          color: #333;
        }

        .body-text {
          margin-bottom: 32px;

          p {
            font-size: 16px;
            font-weight: 400;
            line-height: 22px;
            margin-bottom: 12px;
            color: #333;

            &.bold-text {
              font-weight: 600;
            }
          }
        }

        .button-container {
          text-align: center;
        }
      }
    }
  }
</style>
